// import React, { useRef, useEffect } from "react";
// import image from "../images/about-us.webp";
// import { Fade } from "react-awesome-reveal";
// import autoAnimate from "@formkit/auto-animate";

// const About = (props) => {
//   const ref = useRef(null);

//   useEffect(() => {
//     ref.current && autoAnimate(ref.current);
//   }, []);

//   return (
//     <div
//       id="about"
//       ref={ref}
//       className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 text-gray-800"
//     >
//       <div className="container mx-auto  flex flex-col md:flex-row items-center gap-3">
//         {/* Image Section */}
//         <Fade triggerOnce direction="left">
//           <div className="w-screen md:w-1/2  mx-0 md:mx-4 flex   transform transition-all duration-500 hover:scale-105">
//             <img
//               src={image}
//               alt="About Us"
//               className="rounded-2xl shadow-2xl w-screen h-auto max-w-md md:max-w-lg border-4 border-white"
//             />
//           </div>
//         </Fade>

//         {/* Text Section */}
//         <Fade triggerOnce direction="right" delay={200}>
//           <div className="md:w-auto  w-auto text-center md:text-left">
//             <h2 className="text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600 mb-6">
//               About Us
//             </h2>
//             <p className="text-lg leading-relaxed text-gray-700 mb-8">
//               {props.data ? props.data.paragraph : "Loading..."}
//             </p>

//             <h3 className="text-3xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600 mb-6">
//               Why Choose Us?
//             </h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <ul className="space-y-3">
//                 {props.data
//                   ? props.data.Why.map((d, i) => (
//                       <Fade
//                         triggerOnce
//                         key={`${d}-${i}`}
//                         direction="up"
//                         delay={300 + i * 100}
//                       >
//                         <li className="flex items-center bg-white bg-opacity-50 backdrop-blur-lg rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow duration-300">
//                           <span className="text-blue-500 text-xl mr-3">✔</span>
//                           <span className="text-gray-700">{d}</span>
//                         </li>
//                       </Fade>
//                     ))
//                   : "Loading..."}
//               </ul>
//               <ul className="space-y-3">
//                 {props.data
//                   ? props.data.Why2.map((d, i) => (
//                       <Fade
//                         triggerOnce
//                         key={`${d}-${i}`}
//                         direction="up"
//                         delay={500 + i * 100}
//                       >
//                         <li className="flex items-center bg-white bg-opacity-50 backdrop-blur-lg rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow duration-300">
//                           <span className="text-blue-500 text-xl mr-3">✔</span>
//                           <span className="text-gray-700">{d}</span>
//                         </li>
//                       </Fade>
//                     ))
//                   : "Loading..."}
//               </ul>
//             </div>
//           </div>
//         </Fade>
//       </div>
//     </div>
//   );
// };

// export default About;

import React, { useEffect, useRef } from "react";
import image from "../images/about-us.webp";
import { Fade } from "react-awesome-reveal";
import autoAnimate from "@formkit/auto-animate";

const About = ({ data }) => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current && autoAnimate(ref.current);
  }, []);

  return (
    <section
      id="about"
      ref={ref}
      className="relative w-full bg-gradient-to-b from-white to-blue-50 text-gray-800 py-24 px-6 md:px-12 border-t-2"
    >
      <div className="max-w-6xl mx-auto">
        {/* Floating Image on Top
        <Fade triggerOnce direction="down">
          <div className="relative w-full flex justify-center mb-16">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl max-w-md">
              <img
                src={image}
                alt="About Us"
                className="object-cover w-full h-auto"
              />
            </div>
            <div className="absolute top-6 left-6 right-6 bottom-6 bg-blue-100 rounded-3xl blur-xl z-0"></div>
          </div>
        </Fade> */}

        {/* Text Content */}
        <div className="text-center">
          <Fade triggerOnce direction="up">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                About Us
              </span>
            </h2>
          </Fade>

          <Fade triggerOnce delay={100}>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed mb-12">
              {data ? data.paragraph : "Loading..."}
            </p>
          </Fade>
        </div>

        {/* Divider */}
        <div className="border-t border-blue-200 my-12 w-20 mx-auto"></div>

        {/* Why Choose Us Section */}
        <Fade triggerOnce direction="up" delay={200}>
          <h3 className="text-center text-3xl font-semibold mb-10 text-gray-900">
            Why Choose Us?
          </h3>
        </Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 text-left">
          {/* Left Reasons */}
          <ul className="space-y-6">
            {data
              ? data.Why.map((item, i) => (
                  <Fade key={i} triggerOnce direction="left" delay={i * 100}>
                    <li className="flex items-start gap-4">
                      <div className="text-white bg-blue-600 w-8 h-8 rounded-full flex items-center justify-center font-bold shadow">
                        {i + 1}
                      </div>
                      <p className="text-gray-700 text-base">{item}</p>
                    </li>
                  </Fade>
                ))
              : "Loading..."}
          </ul>

          {/* Right Reasons */}
          <ul className="space-y-6">
            {data
              ? data.Why2.map((item, i) => (
                  <Fade key={i} triggerOnce direction="right" delay={i * 100}>
                    <li className="flex items-start gap-4">
                      <div className="text-white bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center font-bold shadow">
                        {i + 1 + data.Why.length}
                      </div>
                      <p className="text-gray-700 text-base">{item}</p>
                    </li>
                  </Fade>
                ))
              : "Loading..."}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;

